<div class="main-container h-full flex justify-content-center align-items-start">
  <ng-content style="position: relative"></ng-content>
</div>
